import { render, staticRenderFns } from "./ApprovedInvoices.vue?vue&type=template&id=14885e2b&scoped=true"
import script from "./ApprovedInvoices.vue?vue&type=script&lang=js"
export * from "./ApprovedInvoices.vue?vue&type=script&lang=js"
import style0 from "./ApprovedInvoices.vue?vue&type=style&index=0&id=14885e2b&prod&lang=scss&scoped=true"
import style1 from "./ApprovedInvoices.vue?vue&type=style&index=1&id=14885e2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14885e2b",
  null
  
)

export default component.exports